export const FETCH_IMAGES_SUCCESS = "FETCH_IMAGES_SUCCESS";
export const FETCH_IMAGES_FAILURE = "FETCH_IMAGES_FAILURE";
export const IMAGES_SAVE_SUCCESS = "IMAGES_SAVE_SUCCESS";
export const IMAGES_SAVE_FAILURE = "IMAGES_SAVE_FAILURE";
export const IMAGE_ARCHIVE_SUCCESS = "IMAGE_ARCHIVE_SUCCESS";
export const IMAGE_ARCHIVE_FAILURE = "IMAGE_ARCHIVE_FAILURE";
export const IMAGE_COPY_CODE_SUCCESS = "IMAGE_COPY_CODE_SUCCESS";
export const IMAGE_COPY_CODE_FAILURE = "IMAGE_COPY_CODE_FAILURE";
